/** One armed removal at a time; any other action cancels it. */
export function nextKickArmed(current, action) {
  if (action.type === 'arm') return action.id;
  if (action.type === 'occupants') return action.ids.includes(current) ? current : null;
  if (action.type === 'escape' || action.type === 'timeout' || action.type === 'other-control') return null;
  return current;
}
